import routes from "@/lib/routes";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";

const LogoSPOOX = dynamic(() => import("../../svgs/logo_spoox.svg"));

function HeaderLogo({ noTransition }) {
  const router = useRouter();
  const href = noTransition ? "#" : routes.home;
  const handleClick = useCallback(
    (e) => {
      if (noTransition) {
        e.preventDefault();
        return false;
      }
    },
    [noTransition]
  );
  const headerPageReload = router.asPath.includes(routes.restricted);
  return (
    <div className={classnames(styles.logoWrapper)}>
      {!headerPageReload && (
        <Link href={href} onClick={handleClick}>
          <LogoSPOOX className={styles.logoSVG}></LogoSPOOX>
        </Link>
      )}
      {headerPageReload && <a href={href}></a>}
    </div>
  );
}
export default memo(HeaderLogo);
